import { DeliveryRepository } from '@/core/repositories/delivery.repository'
import {
    DeliveryExpressOrderPayloadT,
    DeliveryGetCitiesResponseT,
    DeliveryGetOrderResponseT,
    DeliveryGetOrdersFilters,
    DeliveryGetOrdersResponseT,
    DeliveryGetTariffsResponseT,
    DeliveryGetTasksResponseT,
    DeliveryPointT,
    DeliveryUpdateStatusResponseT,
} from '../types/delivery.types'

const deliveryRepository = new DeliveryRepository()

export class DeliveryService {
    async getCities(
        page: number,
        search?: string,
        limit?: number
    ): Promise<DeliveryGetCitiesResponseT> {
        const response = await deliveryRepository.getCities(page, search, limit)
        return response.data
    }

    async getTariffs(coordinates: DeliveryPointT[]): Promise<DeliveryGetTariffsResponseT> {
        const response = await deliveryRepository.getTariffs(coordinates)
        return response.data
    }

    async createExpressOrder(payload: DeliveryExpressOrderPayloadT): Promise<void> {
        const response = await deliveryRepository.createExpressOrder(payload)
        return response.data
    }

    async getExpressOrders(filters: DeliveryGetOrdersFilters): Promise<DeliveryGetOrdersResponseT> {
        const response = await deliveryRepository.getExpressOrders(filters)
        return response.data
    }

    async getExpressOrder(order_id: number): Promise<DeliveryGetOrderResponseT> {
        const response = await deliveryRepository.getExpressOrder(order_id)
        return response.data
    }

    async getTasks(page: number): Promise<DeliveryGetTasksResponseT> {
        const response = await deliveryRepository.getTasks(page)
        return response.data
    }

    async refreshStatus(order_id: number): Promise<DeliveryUpdateStatusResponseT> {
        const response = await deliveryRepository.refreshStatus(order_id)
        return response.data
    }

    async cancelOrder(id: number): Promise<void> {
        const response = await deliveryRepository.cancelOrder(id)
        return response.data
    }

    async cancelOrderByReceiver(id: number): Promise<void> {
        const response = await deliveryRepository.cancelOrderByReceiver(id)
        return response.data
    }

    async addToAccrual(order_id: number): Promise<void> {
        const response = await deliveryRepository.addToAccrual(order_id)
        return response.data
    }

    async massApprove(form_data: FormData): Promise<void> {
        const response = await deliveryRepository.massApprove(form_data)
        return response.data
    }
}
